<template>
    <WarningBlock
        v-if="showPastDueWarning"
        class="mt-6"
        :title="t('vue.past_due_subscription_warning_title')"
        :description="t('vue.past_due_subscription_warning_description')"
    >
        <template #actions>
            <AtomicButton
                color="yellow"
                size="md"
                class="h-8 shrink-0 px-4 text-[12px] font-semibold leading-4"
                @click="router.visit(route('billing.subscriptions.index'))"
            >
                {{ t("vue.past_due_subscription_update_payment") }}
            </AtomicButton>
        </template>
    </WarningBlock>
</template>

<script setup lang="ts">
import { router } from "@inertiajs/vue3";
import route from "ziggy-js";
import AtomicButton from "@/components/Atomic/Buttons/AtomicButton.vue";
import WarningBlock from "@/components/Atomic/Miscellaneous/WarningBlock.vue";
import { useTranslations } from "@/composables/useTranslations.ts";
import usePastDueWarning from "@/composables/usePastDueWarning.ts";

const { t } = useTranslations();
const { showPastDueWarning } = usePastDueWarning();
</script>
